import styled from 'styled-components';
import { InputBase } from '@mui/material';
import colors from '../../../../styles/colors';

const QueueLabel = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  color: ${colors.base.secondary2};
`;

const ScheduleQueueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ScheduleQueueCard = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 8px;
  background: ${colors.base.alpha};
  font-size: 12px;
  gap: 8px;
`;

const ScheduleQueueTextArea = styled(InputBase)`
  flex: 1;
  font-size: 12px;
  color: ${colors.base.beta};
  min-height: 60px;

  & textarea {
    word-break: break-word;
  }
`;

export {
  QueueLabel,
  ScheduleQueueContainer,
  ScheduleQueueCard,
  ScheduleQueueTextArea,
};
